import { formatMoney, formatUnitPrice } from '../../../utils/money';
import { localeForLanguage, THOUSANDS_GROUPING } from '../../../utils/numberFormatting';
import { formatCurrency, formatCurrencyUnitPrice } from '../../../utils/currency';

/** Readout number: localized, up to `maxDigits` decimals, no forced zeros. */
export function formatReadout(value: number | null | undefined, maxDigits = 2, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString(localeForLanguage(language), { maximumFractionDigits: maxDigits, ...THOUSANDS_GROUPING } as Intl.NumberFormatOptions);
}

/** PLN amount with the currency sign used on the product card. */
export function formatZloty(value: number | null | undefined, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${formatMoney(value, language)} zł`;
}

/** Unit cost (2 decimals, money.ts formatUnitPrice) with the currency sign. */
export function formatUnitZloty(value: number | null | undefined, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${formatUnitPrice(value, language)} zł`;
}

/** Average-cost amount in its own currency (PLN reads as on the rest of the card). */
export function formatCostAmount(value: number | null | undefined, currency: string = 'PLN', language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return currency === 'PLN' ? formatZloty(value, language) : formatCurrency(value, currency);
}

/** Average-cost unit price (2 decimals) in its own currency. */
export function formatUnitCost(value: number | null | undefined, currency: string = 'PLN', language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return currency === 'PLN' ? formatUnitZloty(value, language) : formatCurrencyUnitPrice(value, currency, language);
}
